import { ON_PESQUISAR_STATUS_OPERACAO } from '../actions/dashboard.actions'

const initialSystemState = {
  statusOperacoes: {
    status: [],
    pInicial: null,
    pFinal: null,
  },
}

export default function (state = initialSystemState, action) {
  switch (action.type) {
    case ON_PESQUISAR_STATUS_OPERACAO:
      const { pInicial, pFinal, status } = action.payload
      return {
        ...state,
        statusOperacoes: { pInicial, pFinal, status },
      }
    default:
      return state
  }
}
